/* eslint-disable react/jsx-props-no-spreading ,react/destructuring-assignment,  @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react'
import { SelectItems } from '../../types/select'
import { Selection } from './styled-components'

interface SelectProps {
  options: SelectItems[]
  defaultValue?: SelectItems
  onChange?: (option: SelectItems) => void
}

function Select({
  options,
  onChange,
  defaultValue,
}: SelectProps): ReactElement {
  return (
    <Selection
      options={options}
      classNamePrefix="Select"
      defaultValue={defaultValue || options[0]}
      onChange={onChange as any}
      isSearchable={false}
      isRtl
    />
  )
}

export default Select
